angular.module('rxrefills').factory('RxRefillRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        var getRxRefills = function (uid, expiring) {
            expiring = !!expiring; //|| false;
            var restangular = AprimaRestangular.get('patient');
            //todo: need to get serperate pharmacy list, should controller care about how the calls to the endpoints work?
            //return restangular.one('rxrefills', uid).customGET(expiring);//get();
            return restangular.one('rxrefills', uid).get({expiring: expiring});
        };

        var putRxRefills = function (uid, rxRefilRequest) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('rxrefills', uid).customPUT(rxRefilRequest);
        };

        function getPharmacies(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/pharmacies').get();
        }

        function postMedicationsAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/medications').customPOST(reportRequestDto);
        }

        return{
            getRxRefills: getRxRefills,
            getPharmacies: getPharmacies,
            putRxRefills: putRxRefills,
            postMedicationsAudit : postMedicationsAudit
        };
    }]);

